// extracted by mini-css-extract-plugin
module.exports = {"mobileNutritionScore":"_1ZVf7WOhAM1qrIBjheo4uh"};